'use strict';

module.exports = function () {
    $('body').on('click', '.js-subscription-address', function (e) {
        e.preventDefault();

        $('.modal').modal('hide');
        $('body').removeClass('modal-open');
        $('.modal-backdrop').remove();
        $('#subscriptionAddressModal').modal('show');
    });
};
